import { INote } from '../types'
import { pb } from '../pocketbase/Pocketbase'

interface IDetailRowWithPillsProps {
  label: string
  notes: INote[]
  isLast?: boolean
}

export const DetailRowWithPills = (props: IDetailRowWithPillsProps) => {
  const getImageUrl = (note: INote) => {
    if (note.image) {
      return pb.files.getURL({ id: note.id, collectionName: 'notes' }, note.image, { thumb: '100x100' })
    }
    return null
  }

  return (
    <div
      className={`flex flex-row justify-between items-center ${props.isLast ? '' : 'md:pb-[28px] pb-5 border-b-1 border-formSubSep'}`}
    >
      <div className={'md:text-xl text-lg text-primaryText font-sf-pro-light'}>
        {props.label}
      </div>
      <div className={'flex flex-wrap md:gap-10 gap-3 justify-end max-w-2/3'}>
        {props.notes.map((note) => {
          const imageUrl = getImageUrl(note)
          return (
            <div
              key={note.id}
              className={'flex flex-col items-center md:gap-2 gap-1.5'}
            >
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt={note.name}
                  className="md:w-15 md:h-15 w-12 h-12 rounded-full object-cover"
                />
              ) : (
                <div className="md:w-15 md:h-15 w-12 h-12 rounded-full bg-gray-300" />
              )}
              <span className="md:text-lg text-sm font-sf-pro-light text-center text-primaryText">
                {note.name}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
